import API from '../services/api';

const api = new API();
const URL_AI_CONTEXT = 'api/ai-context';
const URL_AI_CONTEXT_VERSIONS = 'api/ai-context/versions';

export const CONFLICT_ERROR = 'ai_context_conflict';

const normalizeConflictError = err => {
    const payload = err?.value;

    if (err?.status === 1 && payload && payload.error === 'conflict') {
        return {
            type: CONFLICT_ERROR,
            baseVersionId: payload.base_version_id ?? null,
            latestVersionId: payload.latest_version_id ?? null,
            latestCreatorEmail: payload.latest_creator_email ?? null,
            latestCreated: payload.latest_created ?? null,
            conflicts: payload.conflicts || [],
        };
    }

    return err;
};

const getContext = () =>
    new Promise((resolve, reject) => {
        api.getJson(URL_AI_CONTEXT, {
            method: 'GET',
            credentials: 'include',
            unique: true,
            disableBrowserCache: true,
        })
            .then(response =>
                resolve({
                    answers: response?.value?.answers || {},
                    maxLengths: response?.value?.max_lengths || {},
                    latestVersionId: response?.value?.latest_version_id ?? null,
                })
            )
            .catch(reject);
    });

const saveAnswers = (answers, baseVersionId) =>
    new Promise((resolve, reject) => {
        api.getJson(URL_AI_CONTEXT, {
            method: 'POST',
            credentials: 'include',
            unique: true,
            fixErr: true,
            body: { answers, base_version_id: baseVersionId ?? null },
        })
            .then(response =>
                resolve({
                    answers: response?.value?.answers || {},
                    latestVersionId: response?.value?.latest_version_id ?? null,
                })
            )
            .catch(err => reject(normalizeConflictError(err)));
    });

const listVersions = () =>
    new Promise((resolve, reject) => {
        api.getJson(URL_AI_CONTEXT_VERSIONS, {
            method: 'GET',
            credentials: 'include',
            unique: true,
            disableBrowserCache: true,
        })
            .then(response => resolve(response?.value?.versions || []))
            .catch(reject);
    });

const getVersion = versionId =>
    new Promise((resolve, reject) => {
        api.getJson(`${URL_AI_CONTEXT_VERSIONS}/${versionId}`, {
            method: 'GET',
            credentials: 'include',
            unique: true,
            disableBrowserCache: true,
        })
            .then(response => resolve(response?.value?.answers || {}))
            .catch(reject);
    });

const restoreVersion = (versionId, baseVersionId) =>
    new Promise((resolve, reject) => {
        api.getJson(`${URL_AI_CONTEXT_VERSIONS}/${versionId}/restore`, {
            method: 'POST',
            credentials: 'include',
            unique: true,
            fixErr: true,
            body: { base_version_id: baseVersionId ?? null },
        })
            .then(response =>
                resolve({
                    answers: response?.value?.answers || {},
                    latestVersionId: response?.value?.latest_version_id ?? null,
                })
            )
            .catch(err => reject(normalizeConflictError(err)));
    });

export default { getContext, saveAnswers, listVersions, getVersion, restoreVersion };
